/* src/app/views/template/components/templates/print/print-label-templates/print-label-templates.component.scss */
/*# sourceMappingURL=print-label-templates.component.css.map */
